import React from "react";
import "./pagination.css";

const Pagination = ({ currentPage, handlePageChange, noOfPages }) => {
  return (
    <div className="pagination-wrapper">
      <div className="pagination-container">
        <button
          className="pagination-btn pagination-prev"
          disabled={currentPage === 1}
          onClick={() => handlePageChange("Prev")}
        >
          <svg
            className="pagination-icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
          <span>Previous</span>
        </button>

        <div className="pagination-info">
          <span className="pagination-current">{currentPage}</span>
          <span className="pagination-separator">/</span>
          <span className="pagination-total">{noOfPages}</span>
        </div>

        <button
          className="pagination-btn pagination-next"
          disabled={currentPage === noOfPages}
          onClick={() => handlePageChange("Next")}
        >
          <span>Next</span>
          <svg
            className="pagination-icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Pagination;
